import { message, notification } from "antd";
import axios from "axios";
import { store } from "../app/store";
import { selectToken, clearAuthen } from "../app/features/authen";
const host = window.location.hostname;
const DOMAIN =
  host.search("localhost") >= 0 || host.search("test") >= 0
    ? "https://api-staging.sphacy.vn/"
    : host.search("staging") >= 0
    ? "https://api-staging.sphacy.vn/"
    : host.search("real") >= 0
    ? "https://apigpp-real.sphacy.vn/"
    : "https://apigpp.sphacy.vn/";
console.log(DOMAIN);

const fetchAuth = () => {
  const state = store.getState();
  const token = selectToken(state);
  return token;
};

export const get = async (func, params = {}) => {
  let url = DOMAIN + func;
  const token = fetchAuth();
  const requestConfig = token
    ? {
        headers: {
          token: token,
        },
        params,
      }
    : {
        params,
      };
  const response = await axios.get(url, requestConfig);
  return response.data;
};

export const post = async (
  func,
  params = {},
  body = {},
  headers = {
    "Content-Type": "application/json",
  }
) => {
  headers.token = fetchAuth();

  let url = DOMAIN + func;
  const response = await axios.post(url, body, {
    headers: headers,
    params,
  });
  return response.data;
};

export const execute = async (response, isShowProgress) => {
  try {
    if (response.ERR_CODE === "200") {
      if (response.RESULT) {
        if (isShowProgress) {
          notification["success"]({
            message: "Success",
          });
        }
        return response.RESULT;
      }
      return response;
    } else if (response.ERR_CODE === -1) {
      store.dispatch(clearAuthen());
      notification["error"]({
        message: "Xác thực tài khoản thất bại",
        description: "Bạn cần đăng nhập để tiếp tục sử dụng tính năng này",
      });
      throw response;
    }
    notification["error"]({
      message: "Có lỗi xảy ra",
      description: response.ERR_MSG,
    });
    throw response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
